/* ============================================================
   UTcart v2 — Bridge JS — BUILD B4-FR-2026-08-15 + PACK-FR-2026-09-08 (deep session: single-flight cart.js,
   purge des codes non cumulables + avis visible, pre-checks basés sur Shopify)
   
   Functional JS for the new drawer. Handles:
   - Open/close (global openCart/closeCart/handleAddToCart)
   - Render line items from Cart API
   - Progress bar with 3 thresholds
   - Gift banner + gift selection slide panel
   - Upsell cards from inline Liquid JSON
   - Discount toggle
   - COD checkbox
   
   Full ndkProductCache + variante _regalo_/_upsell_ logic = Fase B.
   ============================================================ */

(function () {
  'use strict';

  var overlay = document.getElementById('utcart-overlay');
  var drawer = document.getElementById('utcart-drawer');
  var mainView = document.getElementById('utcart-main');
  var giftSelView = document.getElementById('utcart-gift-selection');
  var body = document.body;

  if (!overlay || !drawer) return;

  // --- Loading overlay (blocks interaction during discount operations) ---
  var loadingOverlay = document.createElement('div');
  loadingOverlay.id = 'utcart-loading';
  loadingOverlay.style.cssText = 'display:none;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.6);z-index:10000;justify-content:center;align-items:center;';
  loadingOverlay.innerHTML = '<div style="width:32px;height:32px;border:3px solid #ccc;border-top-color:#333;border-radius:50%;animation:utcart-spin 0.7s linear infinite"></div>';
  // Add keyframes if not present
  if (!document.getElementById('utcart-spin-style')) {
    var spinStyle = document.createElement('style');
    spinStyle.id = 'utcart-spin-style';
    spinStyle.textContent = '@keyframes utcart-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(spinStyle);
  }
  // Bold amounts in progress labels
  document.querySelectorAll('.utcart-progress__label').forEach(function(el) {
    el.innerHTML = el.textContent.replace(/(>[0-9]+€)/, '<b>$1</b>');
  });
  drawer.appendChild(loadingOverlay);

  function showLoading() { loadingOverlay.style.display = 'flex'; }
  function hideLoading() { loadingOverlay.style.display = 'none'; }

  // --- Settings ---
  var S = {};
  try {
    var sEl = document.getElementById('utcart-settings');
    if (sEl) S = JSON.parse(sEl.textContent);
  } catch (e) {}

  var sym = S.currency_symbol || '\u20AC';
  var t1 = S.threshold_shipping || 3500;
  var t2 = S.threshold_gift_1 || 7000;
  var t3 = S.threshold_gift_2 || 12000;
  var codSurcharge = S.cod_surcharge || 300;

  // Upsell map — refreshed dynamically via Section Rendering API
  var upsellMap = [];
  var _upsellMapItemKeys = ''; // cache key based on cart items

  function refreshUpsellMap(force) {
    // Build a cache key from current cart item variant IDs
    var itemKeys = lastCart ? lastCart.items.map(function(i) { return i.variant_id; }).sort().join(',') : '';
    if (!force && itemKeys === _upsellMapItemKeys && upsellMap.length > 0) return Promise.resolve();
    _upsellMapItemKeys = itemKeys;

    return fetch('/?sections=utcart-upsell-data')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections['utcart-upsell-data'] || '';
        var match = html.match(/<script[^>]*id="utcart-upsell-map"[^>]*>([\s\S]*?)<\/script>/);
        if (match && match[1]) {
          var raw = match[1].replace(/,\s*\]/g, ']').replace(/,\s*\}/g, '}');
          upsellMap = JSON.parse(raw).filter(function(u) { return u && u.upsell_handle; });
        } else {
          upsellMap = [];
        }
      })
      .catch(function(e) {
        console.error('UTcart v2 upsell refresh error:', e);
      });
  }

  // Track upsell variant IDs added during this session
  var addedUpsellVariants = {}; // { variantId: triggerProductId }

  var _variantMetaItemKeys = '';

  function refreshVariantMeta(force) {
    var itemKeys = lastCart ? lastCart.items.map(function(i) { return i.variant_id; }).sort().join(',') : '';
    if (!force && itemKeys === _variantMetaItemKeys && Object.keys(variantMeta).length > 0) return Promise.resolve();
    _variantMetaItemKeys = itemKeys;

    return fetch('/?sections=utcart-variant-meta')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var raw = sections['utcart-variant-meta'] || '{}';
        // Section Rendering may wrap in a div, extract JSON
        var jsonMatch = raw.match(/\{[\s\S]*\}/);
        if (jsonMatch) {
          try {
            variantMeta = JSON.parse(jsonMatch[0]);
          } catch(e) {
            console.warn('UTcart v2: variant meta parse error', e);
          }
        }
      })
      .catch(function(e) {
        console.warn('UTcart v2: variant meta refresh error', e);
      });
  }

  // State
  var lastCart = null;
  var giftProducts = null;
  var giftCompareAtPrices = {}; // { variantId: compare_at_price_in_cents }
  var selectedGifts = [];
  var codChecked = false;
  var _hasFreeShippingCode = false; // set by renderFooter, read by renderProgress
  var userCodes = []; // discount codes applied by the user in this session
  var _expiredNotified = false; // one-time flag for expired code notification
  var _displacedNotified = {}; // one-time-per-code flags for displaced (non-combining) codes
  var variantMeta = {}; // { variantId: { days, cart_label, variant_title } }
  var availableGiftCount = S.available_gift_count || 0;

  // Load gift products from Liquid-injected JSON (real-time availability)
  try {
    var giftDataEl = document.getElementById('utcart-gift-products');
    if (giftDataEl) {
      giftProducts = JSON.parse(giftDataEl.textContent);
      giftProducts.forEach(function(g) {
        // Guard: compare_at_price must be cents. A recurring theme-fork regression
        // re-adds "| times: 100" in the Liquid; no gift costs 500€+, so anything
        // above 50000 cents is that bug — undo it here.
        if (g.compare_at_price > 50000) g.compare_at_price = Math.round(g.compare_at_price / 100);
        if (g.compare_at_price > 0) {
          giftCompareAtPrices[g.variant_id] = g.compare_at_price;
        }
      });
    }
  } catch(e) { console.warn('UTcart v2: gift products parse error', e); }

  // Load initial variant meta from Liquid-injected JSON
  try {
    var metaEl = document.getElementById('utcart-variant-meta');
    if (metaEl) variantMeta = JSON.parse(metaEl.textContent);
  } catch(e) { console.warn('UTcart v2: variant meta parse error', e); }

  // --- Helpers ---

  /**
   * NDK 2026-08: single-flight de GET /cart.js — les appels concurrents partagent
   * UNE requête en vol. Pas de cache temporel (zéro risque de panier obsolète).
   */
  var _cartInFlight = null;
  function getCartJson() {
    if (_cartInFlight) return _cartInFlight;
    _cartInFlight = fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(
        function(cart) { _cartInFlight = null; return cart; },
        function(err) { _cartInFlight = null; throw err; }
      );
    return _cartInFlight;
  }

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + sym;
  }

  /**
   * Get display label for days/duration from variant meta.
   * Priority: cart_label > days metafield > parse variant_title > null
   */
  function getDaysLabel(variantId, itemVariantTitle) {
    var meta = variantMeta[String(variantId)] || {};

    // 1. Override: cart_label metafield
    if (meta.cart_label && meta.cart_label.trim()) {
      return meta.cart_label.trim();
    }

    // 2. days metafield (integer)
    if (meta.days && meta.days > 0) {
      return meta.days + ' jours';
    }

    // 3. Parse variant title for days pattern
    var title = itemVariantTitle || meta.variant_title || '';
    // Match "30 días", "20 dias", "30days", "30 jours", "60 jours"
    var daysMatch = title.match(/(\d+)\s*(?:d[ií]as?|jours?|days?|giorni)/i);
    if (daysMatch) return daysMatch[1] + ' jours';

    var mesMatch = title.match(/(\d+)\s*(?:mes(?:es)?|mois)/i);
    if (mesMatch) return mesMatch[0];

    // 4. Just a number (e.g. "30") — treat as days
    var numOnly = title.match(/^(\d+)$/);
    if (numOnly) return numOnly[1] + ' jours';

    return null;
  }

  function getSizedImg(url, size) {
    if (!url) return '';
    return url.replace(/(\.\w+)(\?|$)/, '_' + size + '$1$2');
  }

  function isUpsellItem(item) {
    return item.sku && item.sku.indexOf('upsell_') === 0;
  }

  function isGiftItem(item) {
    return item.price === 0
      || (item.sku && item.sku.indexOf('regalo_') === 0)
      || (item.variant_title && item.variant_title.indexOf('_regalo_') > -1);
  }

  function isSpecialItem(item) {
    return isUpsellItem(item) || isGiftItem(item);
  }

  /** Lines built by the pack builder page (assets/ndk-pack-builder.js sets this property). */
  function isPackItem(item) {
    return !!(item.properties && item.properties._ndk_pack);
  }

  /**
   * What the customer actually pays for a line, after the pack's line-level discount and this
   * line's share of any order-level code. Single source of truth: the line renderer and the pack
   * group header both call this, so the header can never disagree with the lines inside it.
   */
  function effectiveLinePrice(item) {
    if (_cachedDiscount && _cachedDiscount.type === 'fixed' && item.final_line_price > 0) {
      return item.original_line_price;
    }
    return item.final_line_price - getItemCodeDiscount(item);
  }

  /**
   * Cached discount info — populated from cart_level_discount_applications.
   * Source of truth: value_type from Shopify cart API (NEVER discountData.__typename).
   * Structure: { type: 'percentage'|'fixed', percent: 0.16, amount: 1517, title: 'FLASH' } or null
   */
  var _cachedDiscount = null;

  /**
   * Per-line share of the ORDER discount, keyed by line item key, with the rounding remainder
   * absorbed by the last line so the displayed line prices add up to the cart total exactly.
   * Populated by detectDiscount(); read by getItemCodeDiscount().
   */
  var _codeShares = null;

  /**
   * Detect and cache discount from cart API.
   * Source of truth: cart_level_discount_applications[].value_type
   *   - "percentage" → FLASH-type (order discount, percentage)
   *   - "fixed_amount" → 3PZ4RMSD-type (order discount, fixed amount)
   *   - absent → no order discount (COMBO or ENVIO or none)
   * NEVER reads discountData.__typename (global.js misclassifies fixed as percentage).
   */
  function detectDiscount(cart) {
    if (!cart) { _cachedDiscount = null; _codeShares = null; return; }

    var apps = cart.cart_level_discount_applications || [];
    if (apps.length === 0) { _cachedDiscount = null; _codeShares = null; return; }

    // Read the first order discount (only one order discount type active at a time)
    var d = apps[0];
    var title = d.title || '';
    var amount = d.total_allocated_amount || 0;

    if (d.value_type === 'percentage') {
      // Calculate actual percent from original prices (not final, which COMBO may have altered)
      var origSubtotal = 0;
      cart.items.forEach(function(item) {
        if (!isGiftItem(item)) origSubtotal += item.original_line_price;
      });
      var pct = origSubtotal > 0 ? amount / origSubtotal : 0;
      // NOTE: do NOT round pct to 2 decimals. It used to be rounded, which was harmless while the
      // only discounts were order-level: amount/origSubtotal came out at the code's nominal rate
      // and rounding just cleaned up float noise. It stopped being harmless once a LINE-level
      // discount (the pack builder function) sits underneath: Shopify then allocates the code over
      // the already-reduced subtotal, so the ratio is a real fraction (e.g. 13.59%) and snapping it
      // to 14% overcharged every line on screen (measured in ES, 31-aug-2026). Carts with no
      // line-level discount are unaffected.
      _cachedDiscount = { type: 'percentage', percent: pct, amount: amount, title: title };

      // Split the allocated amount across lines and give the remainder to the last one, so the
      // line prices shown in the drawer always add up to the total Shopify charges.
      _codeShares = {};
      var shareLines = cart.items.filter(function(i) {
        return !isGiftItem(i) && i.final_line_price > 0;
      });
      var allocated = 0;
      shareLines.forEach(function(item, idx) {
        var share;
        if (idx === shareLines.length - 1) {
          share = amount - allocated;
        } else {
          var unit = item.price || item.final_price || Math.round(item.final_line_price / item.quantity);
          share = Math.round(unit * pct) * item.quantity;
          allocated += share;
        }
        _codeShares[item.key] = share;
      });
    } else if (d.value_type === 'fixed_amount') {
      _cachedDiscount = { type: 'fixed', percent: 0, amount: amount, title: title };
      _codeShares = null;
    } else {
      _cachedDiscount = null;
      _codeShares = null;
    }
  }

  /**
   * Calculate per-item ORDER discount for PERCENTAGE discounts only.
   * Fixed-amount discounts: return 0 (shown only in footer via cart.total_discount).
   */
  function getItemCodeDiscount(item) {
    if (!_cachedDiscount || _cachedDiscount.type !== 'percentage') return 0;
    if (item.final_line_price <= 0) return 0;
    // Exact per-line share when available (remainder absorbed), so lines add up to the total.
    if (_codeShares && Object.prototype.hasOwnProperty.call(_codeShares, item.key)) {
      return _codeShares[item.key];
    }
    // Apply per-unit on ORIGINAL price (matches PDP display)
    var unitPrice = item.price || item.final_price || Math.round(item.final_line_price / item.quantity);
    var unitDiscount = Math.round(unitPrice * _cachedDiscount.percent);
    return unitDiscount * item.quantity;
  }

  // ========================
  // OPEN / CLOSE
  // ========================
  /**
   * @param {Object} [opts]
   * @param {boolean} [opts.stale] el carrito acaba de cambiar fuera de este módulo (add.js desde
   *   una ficha o desde el pack builder): lo último pintado ya no vale, así que se enseña el
   *   spinner hasta que vuelva cart.js en vez de un carrito viejo.
   */
  function openCart(opts) {
    var stale = !!(opts && opts.stale);
    overlay.classList.remove('utcart--closed');
    overlay.classList.add('utcart--open');
    body.classList.add('utcart-body-locked');
    showMainView();
    if (stale) {
      showLoading();
      var safety = setTimeout(hideLoading, 8000);
      renderCart().then(function() { clearTimeout(safety); hideLoading(); });
      return;
    }
    renderCart();
  }

  function closeCart() {
    overlay.classList.remove('utcart--open');
    overlay.classList.add('utcart--closed');
    body.classList.remove('utcart-body-locked');
  }

  // Close buttons
  drawer.querySelectorAll('.utcart-header__close').forEach(function(btn) {
    btn.addEventListener('click', closeCart);
  });
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeCart(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('utcart--open')) closeCart();
  });

  // ========================
  // VIEW SWITCHING
  // ========================
  function showMainView() {
    if (mainView) mainView.style.display = '';
    if (giftSelView) {
      giftSelView.style.display = 'none';
      giftSelView.classList.remove('utcart-gift-selection--visible');
    }
  }

  function showGiftSelection(isPreviewOverride, forceReset) {
    // Check if we're in preview mode (locked state)
    var banner = document.getElementById('utcart-gift-banner');
    var isPreview = isPreviewOverride === true || (banner && banner.dataset.state === 'locked');
    var titleEl = document.getElementById('utcart-gift-title');
    var subtitleEl = document.getElementById('utcart-gift-subtitle');
    var footer = document.getElementById('utcart-gift-footer');
    var confirmMsg = document.getElementById('utcart-gift-confirm-msg');

    if (mainView) mainView.style.display = 'none';
    if (giftSelView) {
      giftSelView.style.display = 'flex';
      // Toggle preview class on panel
      if (isPreview) {
        giftSelView.classList.add('utcart-gift-selection--preview');
        if (titleEl) titleEl.textContent = 'Cadeaux disponibles';
        if (subtitleEl) {
          var nextThreshold = (lastCart && lastCart.total_price < t2) ? t2 : t3;
          var diff = nextThreshold - (lastCart ? lastCart.total_price : 0);
          subtitleEl.textContent = 'Il vous manque ' + fmt(diff > 0 ? diff : 0) + ' pour obtenir votre cadeau';
          subtitleEl.style.display = '';
        }
        if (footer) footer.style.display = 'none';
      } else {
        giftSelView.classList.remove('utcart-gift-selection--preview');
        var maxGifts = getGiftCount(lastCart ? lastCart.total_price : 0);
        if (titleEl) titleEl.textContent = 'Choisissez ' + maxGifts + ' cadeau' + (maxGifts > 1 ? 'x' : '');
        if (subtitleEl) {
          subtitleEl.textContent = 'Sélectionnez et confirmez pour l\u0027ajouter au panier';
          subtitleEl.style.display = '';
        }
        if (footer) footer.style.display = '';
        // Reset confirm state
        updateGiftConfirmBtn();
        if (confirmMsg) confirmMsg.style.display = 'none';
      }
      requestAnimationFrame(function() {
        giftSelView.classList.add('utcart-gift-selection--visible');
      });
      renderGiftSelection(isPreview, forceReset);
    }
  }

  // Gift panel X close — validates if gifts need confirming
  var giftCloseX = drawer.querySelector('.utcart-gift-close-x');
  if (giftCloseX) giftCloseX.addEventListener('click', function() {
    var banner = document.getElementById('utcart-gift-banner');
    var isPreview = banner && banner.dataset.state === 'locked';

    if (isPreview) {
      // Preview mode — just go back
      showMainView();
      return;
    }

    // Check if user selected gifts but didn't confirm
    if (selectedGifts.length > 0) {
      // Shake the confirm button and show message
      var confirmBtn = document.getElementById('utcart-gift-confirm-btn');
      var confirmMsg = document.getElementById('utcart-gift-confirm-msg');
      if (confirmBtn) {
        confirmBtn.classList.remove('utcart-btn--shake');
        // Force reflow to restart animation
        void confirmBtn.offsetWidth;
        confirmBtn.classList.add('utcart-btn--shake');
        setTimeout(function() { confirmBtn.classList.remove('utcart-btn--shake'); }, 600);
      }
      if (confirmMsg) confirmMsg.style.display = '';
      return;
    }

    showMainView();
  });

  var giftBanner = document.getElementById('utcart-gift-banner');
  if (giftBanner) giftBanner.addEventListener('click', showGiftSelection);

  var giftConfirmBtn = document.getElementById('utcart-gift-confirm-btn');
  if (giftConfirmBtn) {
    giftConfirmBtn.addEventListener('click', function() {
      if (giftConfirmBtn.disabled) return;
      addSelectedGiftsToCart().then(function() {
        showMainView();
        renderCart();
      });
    });
  }

  function updateGiftConfirmBtn() {
    var btn = document.getElementById('utcart-gift-confirm-btn');
    if (!btn) return;
    var maxGifts = getGiftCount(lastCart ? lastCart.total_price : 0);
    var allSelected = selectedGifts.length >= maxGifts;
    btn.disabled = !allSelected;
    btn.classList.toggle('utcart-btn--disabled', !allSelected);
    // Hide confirm message when selection changes
    var msg = document.getElementById('utcart-gift-confirm-msg');
    if (msg) msg.style.display = 'none';
  }

  // ========================
  // AUTO-CLEAN: remove orphaned upsells + excess gifts
  // ========================
  function autoCleanCart(cart) {
    var updates = {};
    var cartProdIds = cart.items.map(function(i) { return i.product_id; });

    // Problem 4: Remove upsell items whose trigger product is no longer in cart
    cart.items.forEach(function(item) {
      if (addedUpsellVariants[item.variant_id]) {
        var triggerProdId = addedUpsellVariants[item.variant_id];
        if (cartProdIds.indexOf(triggerProdId) < 0) {
          updates[item.key] = 0;
          delete addedUpsellVariants[item.variant_id];
        }
      }
    });

    // Problem 3: Remove gift items if below threshold
    var nonGiftTotal = 0;
    cart.items.forEach(function(i) {
      if (!isGiftItem(i)) {
        nonGiftTotal += i.final_line_price;
      }
    });
    var allowedGifts = getGiftCount(nonGiftTotal);
    var giftItems = cart.items.filter(function(i) {
      return isGiftItem(i);
    });
    if (giftItems.length > allowedGifts) {
      var toRemove = giftItems.slice(allowedGifts);
      toRemove.forEach(function(g) { updates[g.key] = 0; });
    }

    if (Object.keys(updates).length === 0) return Promise.resolve(cart);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function(r) { return r.json(); });
  }

  // ========================
  // CART COUNT (header icon)
  // ========================
  function updateCartCount(cart) {
    // Update all cart count elements in header
    var els = document.querySelectorAll('.cart-link__quantity, #cart_count');
    els.forEach(function(el) {
      el.textContent = cart.item_count;
    });
    // Also sync old theme cart bubble if present
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    bubbles.forEach(function(b) {
      b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
    });
  }

  // ========================
  // RENDER CART
  // ========================
  var _keepError = false; // flag to preserve error message across renderCart

  function renderCart() {
    if (!_keepError) hideDiscError(); // Clear stale errors (but not if we just set one)
    _keepError = false;
    return getCartJson()
      .then(function(cart) {
        lastCart = cart;
        // Detect discount from cart data (instant, cached for per-item calc)
        detectDiscount(cart);
        return autoCleanCart(cart);
      })
      .then(function(cart) {
        lastCart = cart;
        // Refresh upsell map + preload gift products in parallel
        return Promise.all([refreshUpsellMap(), refreshVariantMeta()]).then(function() { return cart; });
      })
      .then(function(cart) {
        renderItems(cart);
        renderGiftItems(cart);
        renderUpsellItems(cart);
        renderUpsells(cart);
        renderFooter(cart);
        renderProgress(cart.total_price);
        toggleEmpty(cart);
        renderGiftBanner(cart.total_price, cart);
        renderDiscountBadges();
        updateCartCount(cart);
      })
      .catch(function(err) { console.error('UTcart v2:', err); });
  }

  // ========================
  // EMPTY STATE
  // ========================
  function toggleEmpty(cart) {
    var isEmpty = cart.item_count === 0;
    var ids = ['utcart-items', 'utcart-gifts', 'utcart-upsell-items', 'utcart-footer', 'utcart-progress', 'utcart-discount', 'utcart-upsells'];
    ids.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = isEmpty ? 'none' : '';
    });
    var emptyEl = document.getElementById('utcart-empty');
    if (emptyEl) emptyEl.style.display = isEmpty ? 'flex' : 'none';
    // Gift banner: hide when empty, otherwise let renderGiftBanner control it
    if (isEmpty) {
      var gb = document.getElementById('utcart-gift-banner');
      if (gb) gb.style.display = 'none';
    }
  }

  // ========================
  // LINE ITEMS
  // ========================
  /**
   * Days label for a line inside the pack. utcart's getDaysLabel() is per-unit; inside the pack
   * the customer thinks in total duration, so 2 units of a 30-day product read as "60 jours" —
   * same rule as the builder page. A non-numeric override (cart_label) is left alone.
   */
  function packDaysLabel(item) {
    var base = getDaysLabel(item.variant_id, item.variant_title) || '';
    var m = base.match(/^(\d+)\s*jours$/i);
    if (m) return (parseInt(m[1], 10) * item.quantity) + ' jours';
    if (item.quantity > 1) return base ? base + ' × ' + item.quantity : '× ' + item.quantity;
    return base;
  }

  /**
   * Render the pack as ONE cart line (design: Julia, Figma 13083-11156 / 13095-7713).
   *
   * Same anatomy as any other line — 72px image slot, name, price on the right — with the pack
   * icon instead of a photo. «Voir les N produits» expands a read-only list: no prices, no
   * quantity steppers, no per-item remove. There is exactly ONE way to change a pack and it is
   * MODIFIER, which goes back to the builder with the pack preloaded.
   *
   * The real cart lines are NOT rendered here; renderItems() skips them. For Shopify they are
   * still N independent lines, so fulfilment, feeds, returns and the discount function are
   * untouched — this is presentation only.
   */
  function renderPackGroup(packLines, container) {
    var tpl = document.getElementById('utcart-tpl-pack-group');
    var itemTpl = document.getElementById('utcart-tpl-pack-item');
    if (!tpl || !itemTpl) return;

    var clone = tpl.content.cloneNode(true);
    var root = clone.querySelector('.utcart-pack');

    var original = 0, effective = 0, units = 0, packFinal = 0;
    packLines.forEach(function(item) {
      original += item.original_line_price;
      effective += effectiveLinePrice(item);
      packFinal += item.final_line_price;
      units += item.quantity;
    });

    // The badge shows the PACK tier, which lives in final_line_price. An order-level code on top
    // lowers the price further but is not part of the pack discount, so it must not inflate this.
    var pct = original > 0 ? Math.round((1 - packFinal / original) * 100) : 0;
    var badge = root.querySelector('.utcart-pack__badge');
    if (pct > 0) { badge.textContent = '\u2212' + pct + '%'; } else { badge.style.display = 'none'; }

    var was = root.querySelector('.utcart-pack__was');
    if (original > effective + 1) { was.textContent = fmt(original); } else { was.style.display = 'none'; }
    root.querySelector('.utcart-pack__now').textContent = fmt(effective);

    root.querySelector('.utcart-pack__toggle-text').textContent =
      'Voir ' + (units === 1 ? '1 produit' : units + ' produits');

    var list = root.querySelector('.utcart-pack__list');
    packLines.forEach(function(item) {
      var li = itemTpl.content.cloneNode(true);
      var img = li.querySelector('.utcart-pack__item-img');
      img.src = getSizedImg(item.image, '120x120');
      img.alt = '';
      li.querySelector('.utcart-pack__item-name').textContent = item.product_title;
      li.querySelector('.utcart-pack__item-days').textContent = packDaysLabel(item);
      // Siempre visible, también con una sola unidad (así está el Figma).
      li.querySelector('.utcart-pack__item-qty').textContent = '\u00d7' + item.quantity;
      list.appendChild(li);
    });

    var contents = root.querySelector('.utcart-pack__contents');
    var toggle = root.querySelector('.utcart-pack__toggle');
    toggle.addEventListener('click', function() {
      var open = contents.hidden;
      contents.hidden = !open;
      root.classList.toggle('utcart-pack--open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // NDK 9-sep-2026 (UX, Gabi/Paolo): «Eliminar» visible en la línea, donde está en cualquier
    // producto; «Editar el pack» pasa al desplegable. La confirmación sale bajo la línea, con el
    // pack abierto o cerrado.
    var confirmRow = root.querySelector('.utcart-pack__confirm');
    var removeBtn = root.querySelector('.utcart-pack__remove');
    removeBtn.addEventListener('click', function() {
      confirmRow.hidden = false;
      removeBtn.hidden = true;
    });
    root.querySelector('.utcart-pack__confirm-no').addEventListener('click', function() {
      confirmRow.hidden = true;
      removeBtn.hidden = false;
    });
    root.querySelector('.utcart-pack__confirm-yes').addEventListener('click', function() {
      // Every pack line to zero in ONE call: done one by one, each removal would recalculate the
      // tier and the customer would watch the price of what is left go UP while it empties.
      var updates = {};
      packLines.forEach(function(item) { updates[item.key] = 0; });
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() { renderCart(); })
        .catch(function(err) { console.error('UTcart v2:', err); });
    });

    container.appendChild(clone);
  }

  function renderItems(cart) {
    var container = document.getElementById('utcart-items');
    var tpl = document.getElementById('utcart-tpl-line-item');
    if (!container || !tpl) return;
    container.innerHTML = '';

    // El pack se pinta como UNA línea propia; sus items no se renderizan como line-items.
    var packLines = cart.items.filter(isPackItem);
    if (packLines.length) renderPackGroup(packLines, container);

    cart.items.forEach(function(item) {
      if (isSpecialItem(item) || isPackItem(item)) return;

      var clone = tpl.content.cloneNode(true);
      var el = clone.querySelector('.utcart-line-item');
      el.dataset.variantId = item.variant_id;
      el.dataset.lineKey = item.key;

      var img = el.querySelector('.utcart-line-item__image');
      if (img) { img.src = getSizedImg(item.image, '200x200'); img.alt = item.product_title; }

      el.querySelector('.utcart-line-item__name').textContent = item.product_title;

      // Price display logic by discount type:
      //   'percentage' (FLASH): ~~original~~ effective (final_line_price - order discount)
      //   'fixed' (3PZ4RMSD): original WITHOUT tachado (Shopify distributes fixed into
      //                        final_line_price but we ignore it — discount only in footer)
      //   no order discount: use Shopify's final_line_price vs original_line_price
      //     → COMBO: ~~original~~ 0,00€ (final_line_price = 0)
      //     → normal: show final_line_price
      var priceEl = el.querySelector('.utcart-line-item__price');
      var oldPriceEl = el.querySelector('.utcart-line-item__price--old');
      var isFixed = _cachedDiscount && _cachedDiscount.type === 'fixed';

      if (isFixed && item.final_line_price > 0) {
        // Fixed: show original price, no tachado
        priceEl.textContent = fmt(item.original_line_price);
        if (oldPriceEl) oldPriceEl.style.display = 'none';
      } else {
        var effectivePrice = effectiveLinePrice(item);
        var hasAnyDiscount = item.original_line_price > effectivePrice + 1;

        if (hasAnyDiscount) {
          if (oldPriceEl) { oldPriceEl.textContent = fmt(item.original_line_price); oldPriceEl.style.display = ''; }
          priceEl.textContent = fmt(effectivePrice);
        } else {
          priceEl.textContent = fmt(item.final_line_price);
          if (oldPriceEl) oldPriceEl.style.display = 'none';
        }
      }

      // Days label
      var daysEl = el.querySelector('.utcart-line-item__days');
      var daysLabel = getDaysLabel(item.variant_id, item.variant_title);
      if (daysEl) {
        if (daysLabel) {
          daysEl.textContent = daysLabel;
        } else {
          daysEl.style.display = 'none';
        }
      }

      el.querySelector('.utcart-qty__value').textContent = item.quantity;

      var minusSpan = el.querySelector('.utcart-qty__minus span');
      if (minusSpan) minusSpan.style.opacity = item.quantity <= 1 ? '0.4' : '1';

      el.querySelector('.utcart-qty__minus').addEventListener('click', updateQty.bind(null, item.key, item.quantity - 1));
      el.querySelector('.utcart-qty__plus').addEventListener('click', updateQty.bind(null, item.key, item.quantity + 1));
      el.querySelector('.utcart-line-item__remove').addEventListener('click', updateQty.bind(null, item.key, 0));

      container.appendChild(clone);
    });
  }

  // ========================
  // GIFT ITEMS (in cart, green bg)
  // ========================
  function renderGiftItems(cart) {
    var container = document.getElementById('utcart-gifts');
    var tpl = document.getElementById('utcart-tpl-gift-item');
    if (!container || !tpl) return;
    container.innerHTML = '';

    cart.items.forEach(function(item) {
      var isGift = isGiftItem(item);
      if (!isGift) return;

      var clone = tpl.content.cloneNode(true);
      var el = clone.querySelector('.utcart-line-item');
      el.dataset.variantId = item.variant_id;
      el.dataset.lineKey = item.key;

      var img = el.querySelector('.utcart-line-item__image');
      if (img) { img.src = getSizedImg(item.image, '136x136'); img.alt = item.product_title; }

      el.querySelector('.utcart-line-item__name').textContent = item.product_title;

      var oldP = el.querySelector('.utcart-line-item__price--old');
      var priceP = el.querySelector('.utcart-line-item__price');
      var cachedCap = giftCompareAtPrices[item.variant_id];
      var capValue = (item.compare_at_price && item.compare_at_price > 0) ? item.compare_at_price : cachedCap;
      if (oldP && capValue && capValue > 0) {
        oldP.textContent = fmt(capValue);
      } else if (oldP) {
        oldP.style.display = 'none';
      }
      // Show 🎁 as price per Figma design
      if (priceP) priceP.textContent = '🎁';

      el.querySelector('.utcart-line-item__remove').addEventListener('click', updateQty.bind(null, item.key, 0));
      var changeBtn = el.querySelector('.utcart-line-item__change-gift');
      if (changeBtn) changeBtn.addEventListener('click', function() { showGiftSelection(false, true); });

      container.appendChild(clone);
    });
  }

  // ========================
  // UPSELL LINE ITEMS (in cart, orange badge)
  // ========================
  function renderUpsellItems(cart) {
    var container = document.getElementById('utcart-upsell-items');
    var tpl = document.getElementById('utcart-tpl-upsell-line-item');
    if (!container || !tpl) return;
    container.innerHTML = '';

    cart.items.forEach(function(item) {
      var isUpsell = isUpsellItem(item);
      if (!isUpsell) return;

      var clone = tpl.content.cloneNode(true);
      var el = clone.querySelector('.utcart-line-item');
      el.dataset.variantId = item.variant_id;
      el.dataset.lineKey = item.key;

      var img = el.querySelector('.utcart-line-item__image');
      if (img) { img.src = getSizedImg(item.image, '136x136'); img.alt = item.product_title; }

      el.querySelector('.utcart-line-item__name').textContent = item.product_title;

      // Days label (upsell)
      var daysEl = el.querySelector('.utcart-line-item__days');
      var daysLabel = getDaysLabel(item.variant_id, item.variant_title);
      if (daysEl) {
        if (daysLabel) {
          daysEl.textContent = daysLabel;
        } else {
          daysEl.style.display = 'none';
        }
      }

      var oldP = el.querySelector('.utcart-line-item__price--old');
      var upsellItemDisc = getItemCodeDiscount(item);
      var displayPrice = item.original_line_price - upsellItemDisc;

      // Upsell strikethrough: prefer compare_at_price, then upsellMap compare
      if (oldP && item.compare_at_price && item.compare_at_price > item.price) {
        oldP.textContent = fmt(item.compare_at_price);
      } else if (oldP) {
        var mapEntry = upsellMap.find(function(u) { return u.upsell_variant_id === item.variant_id; });
        if (mapEntry && mapEntry.upsell_compare_price > item.price) {
          oldP.textContent = fmt(mapEntry.upsell_compare_price);
        } else if (upsellItemDisc > 0) {
          // No product offer, but code discount — show original as tachado
          oldP.textContent = fmt(item.original_line_price);
        } else {
          oldP.style.display = 'none';
        }
      }

      el.querySelector('.utcart-line-item__price').textContent = fmt(displayPrice > 0 ? displayPrice : item.original_line_price);

      el.querySelector('.utcart-line-item__remove').addEventListener('click', updateQty.bind(null, item.key, 0));

      container.appendChild(clone);
    });
  }

  // ========================
  // UPSELLS
  // ========================
  function renderUpsells(cart) {
    var container = document.getElementById('utcart-upsells-list');
    var section = document.getElementById('utcart-upsells');
    var tpl = document.getElementById('utcart-tpl-upsell-card');
    if (!container || !tpl || !section) return;
    container.innerHTML = '';

    var cartProdIds = cart.items.filter(function(i) { return !isUpsellItem(i); }).map(function(i) { return i.product_id; });
    var cartVarIds = cart.items.map(function(i) { return i.variant_id; });
    // Also collect all product IDs in cart (including upsell items) for dedup
    var allCartProdIds = cart.items.map(function(i) { return i.product_id; });

    var seenUpsellProducts = {};
    var valid = upsellMap.filter(function(u) {
      if (!u.upsell_available) return false;
      // Don't suggest if upsell variant is already in cart
      if (cartVarIds.indexOf(u.upsell_variant_id) > -1) return false;
      // Don't suggest if ANY variant of the upsell product is already in cart
      if (u.upsell_product_id && allCartProdIds.indexOf(u.upsell_product_id) > -1) return false;
      // Trigger product must be in cart
      if (cartProdIds.indexOf(u.trigger_product_id) < 0) return false;
      // Deduplicate: only show each upsell product once
      var upId = u.upsell_product_id || u.upsell_handle;
      if (seenUpsellProducts[upId]) return false;
      seenUpsellProducts[upId] = true;
      return true;
    });

    // Max 2 upsells visible
    valid = valid.slice(0, 2);

    if (valid.length === 0) { section.style.display = 'none'; return; }
    section.style.display = '';

    valid.forEach(function(u) {
      var clone = tpl.content.cloneNode(true);
      var el = clone.querySelector('.utcart-upsell-card');
      el.dataset.productHandle = u.upsell_handle;
      el.dataset.variantId = u.upsell_variant_id;

      var img = el.querySelector('.utcart-upsell-card__image');
      if (img) { img.src = u.upsell_image || ''; img.alt = u.upsell_title; }

      el.querySelector('.utcart-upsell-card__text').textContent = u.upsell_text || u.upsell_title;

      var priceEl = el.querySelector('.utcart-upsell-card__price');
      var oldEl = el.querySelector('.utcart-upsell-card__price--old');

      // Calculate discounted upsell price if percentage code active
      var upsellEffective = u.upsell_price;
      if (_cachedDiscount && _cachedDiscount.type === 'percentage' && _cachedDiscount.percent > 0) {
        upsellEffective = u.upsell_price - Math.round(u.upsell_price * _cachedDiscount.percent);
      }
      // Fixed discounts: don't apply to upsell cards (discount is on order total, not per product)

      if (upsellEffective < u.upsell_price) {
        // Code discount active: show upsell_price tachado + discounted price
        // If there's also a compare_at, show compare_at as the tachado instead
        oldEl.textContent = fmt(u.upsell_compare_price && u.upsell_compare_price > u.upsell_price ? u.upsell_compare_price : u.upsell_price);
        oldEl.style.display = '';
        priceEl.textContent = fmt(upsellEffective);
      } else if (u.upsell_compare_price && u.upsell_compare_price > u.upsell_price) {
        priceEl.textContent = fmt(u.upsell_price);
        oldEl.textContent = fmt(u.upsell_compare_price);
        oldEl.style.display = '';
      } else {
        priceEl.textContent = fmt(u.upsell_price);
        if (oldEl) oldEl.style.display = 'none';
      }

      el.querySelector('.utcart-upsell-card__add').addEventListener('click', function() {
        addedUpsellVariants[u.upsell_variant_id] = u.trigger_product_id;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: u.upsell_variant_id, quantity: 1 }] })
        }).then(function() { renderCart(); }).catch(function(err) { console.error('UTcart v2:', err); });
      });

      container.appendChild(clone);
    });
  }

  // ========================
  // GIFT BANNER
  // ========================
  // ========================

  function renderGiftBanner(totalCents, cart) {
    var banner = document.getElementById('utcart-gift-banner');
    if (!banner || !S.enable_gifts) return;
    if (availableGiftCount === 0) { banner.style.display = 'none'; return; }

    var textEl = banner.querySelector('.utcart-gift-banner__text');
    var thumbsEl = document.getElementById('utcart-gift-banner-thumbs');
    var giftCount = getGiftCount(totalCents);
    var giftsInCart = cart ? cart.items.filter(function(i) {
      return isGiftItem(i);
    }).length : 0;

    // Hide only if cart empty or all gifts already in cart
    var isEmpty = !cart || cart.item_count === 0;
    var allGiftsClaimed = giftCount > 0 && giftsInCart >= giftCount;
    if (isEmpty) {
      banner.style.display = 'none';
      return;
    }

    // If all gifts are claimed, hide banner (they are visible as line items)
    if (allGiftsClaimed) {
      banner.style.display = 'none';
      return;
    }

    banner.style.display = '';

    if (giftCount > 0 && giftsInCart < giftCount) {
      // STATE: unlocked — can choose gifts
      var wasLocked = banner.dataset.state === 'locked';
      banner.dataset.state = 'unlocked';
      var remaining = giftCount - giftsInCart;
      textEl.textContent = '🎁 Choisissez ' + (remaining > 1 ? 'vos cadeaux !' : 'votre cadeau !');
      // Render thumbnails (visible in both states per Figma)
      renderBannerThumbs(thumbsEl);
      // Animate attention when transitioning from locked to unlocked
      if (wasLocked || !banner._animPlayed) {
        banner._animPlayed = true;
        banner.classList.remove('utcart-gift-banner--attention');
        void banner.offsetWidth;
        banner.classList.add('utcart-gift-banner--attention');
      }
    } else {
      // STATE: locked — preview only
      banner.dataset.state = 'locked';
      textEl.textContent = '🎁 Voir les Cadeaux';
      // Render thumbnails
      renderBannerThumbs(thumbsEl);
    }
  }

  function renderBannerThumbs(container) {
    if (!container || !giftProducts) return;
    // flat data shape: p.image, p.title
    while (container.firstChild) container.removeChild(container.firstChild);
    giftProducts.forEach(function(p) {
      var imgSrc = p.image || '';
      if (!imgSrc) return;
      var thumb = document.createElement('img');
      thumb.className = 'utcart-gift-banner__thumb';
      thumb.src = imgSrc;
      thumb.alt = p.title;
      thumb.loading = 'lazy';
      container.appendChild(thumb);
    });
  }

  function getGiftCount(cents) {
    var tierCount = 0;
    if (cents >= t3) tierCount = 2;
    else if (cents >= t2) tierCount = 1;
    return Math.min(tierCount, availableGiftCount);
  }

  // ========================
  // GIFT SELECTION PANEL
  // ========================
  function renderGiftSelection(previewMode, forceReset) {
    var container = document.getElementById('utcart-gift-selection-list');
    var tpl = document.getElementById('utcart-tpl-gift-selection-item');
    if (!container || !tpl || !giftProducts) return;

    var maxGifts = getGiftCount(lastCart ? lastCart.total_price : 0);

    container.innerHTML = '';
    selectedGifts = [];

    giftProducts.forEach(function(product) {
      var clone = tpl.content.cloneNode(true);
      var el = clone.querySelector('.utcart-gift-sel-item');
      el.dataset.productId = product.id;
      el.dataset.variantId = product.variant_id;

      var img = el.querySelector('.utcart-gift-sel-item__image');
      if (img) { img.src = product.image || ''; img.alt = product.title; }

      el.querySelector('.utcart-gift-sel-item__name').textContent = product.title;

      var oldP = el.querySelector('.utcart-gift-sel-item__price--old');
      if (oldP && product.compare_at_price > 0) {
        oldP.textContent = fmt(product.compare_at_price);
      } else if (oldP) {
        oldP.style.display = 'none';
      }

      if (previewMode) {
        el.classList.add('utcart-gift-sel-item--locked');
      }

      var inCart = lastCart && lastCart.items.some(function(i) { return i.variant_id === product.variant_id; });
      if (inCart && !previewMode && !forceReset) {
        el.classList.add('utcart-gift-sel-item--selected');
        selectedGifts.push(product.variant_id);
        el.querySelector('.utcart-gift-sel-item__select b').textContent = 'S\u00E9lectionn\u00E9 \u2713';
      }

      if (!previewMode) {
        el.querySelector('.utcart-gift-sel-item__select').addEventListener('click', function(e) {
          e.stopPropagation();
          toggleGift(el, product.variant_id, maxGifts);
        });
        el.addEventListener('click', function() { toggleGift(el, product.variant_id, maxGifts); });
      }

      container.appendChild(clone);
    });
  }

  function toggleGift(el, variantId, maxGifts) {
    var idx = selectedGifts.indexOf(variantId);
    if (idx > -1) {
      selectedGifts.splice(idx, 1);
      el.classList.remove('utcart-gift-sel-item--selected');
      el.querySelector('.utcart-gift-sel-item__select b').textContent = 'Sélectionner';
    } else {
      if (selectedGifts.length >= maxGifts) {
        var first = document.querySelector('.utcart-gift-sel-item--selected');
        if (first) {
          var oldId = +first.dataset.variantId;
          selectedGifts = selectedGifts.filter(function(id) { return id !== oldId; });
          first.classList.remove('utcart-gift-sel-item--selected');
          first.querySelector('.utcart-gift-sel-item__select b').textContent = 'Sélectionner';
        }
      }
      selectedGifts.push(variantId);
      el.classList.add('utcart-gift-sel-item--selected');
      el.querySelector('.utcart-gift-sel-item__select b').textContent = 'Sélectionné \u2713';
    }
    updateGiftConfirmBtn();
  }

  function addSelectedGiftsToCart() {
    if (selectedGifts.length === 0) return Promise.resolve();

    // Remove existing gifts first
    var removes = Promise.resolve();
    if (lastCart) {
      var giftKeys = lastCart.items
        .filter(function(i) { return isGiftItem(i); })
        .map(function(i) { return i.key; });

      giftKeys.forEach(function(key) {
        removes = removes.then(function() {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        });
      });
    }

    return removes.then(function() {
      var items = selectedGifts.map(function(id) { return { id: id, quantity: 1 }; });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).catch(function(err) { console.error('UTcart v2:', err); });
  }

  // ========================
  // FOOTER
  // ========================
  function renderFooter(cart) {
    var shEl = document.getElementById('utcart-shipping-value');
    var toEl = document.getElementById('utcart-total-price');
    var discLine = document.getElementById('utcart-discount-line');
    var discVal = document.getElementById('utcart-discount-value');

    // ── SOURCE OF TRUTH: Shopify's cart totals ──
    // cart.total_price = products with all discounts applied (FLASH, fixed, COMBO)
    // cart.total_discount = total amount discounted
    // cart.original_total_price = products without any discounts
    // We only add: shipping estimate + COD surcharge
    var shopifyTotal = cart.total_price || 0;
    var totalDiscount = cart.total_discount || 0;
    var originalTotal = cart.original_total_price || 0;

    // ── SHIPPING ──
    // Detect free shipping code: applicable code NOT in cart_level_discount_applications
    // and NOT in line_level_discount_allocations = shipping discount
    var hasFreeShippingCode = false;
    if (cart.discount_codes) {
      var orderDiscTitles = (cart.cart_level_discount_applications || []).map(function(a) {
        return (a.title || '').toUpperCase();
      });
      cart.discount_codes.forEach(function(dc) {
        if (dc.applicable === false || !dc.code) return;
        var codeUpper = dc.code.toUpperCase();
        if (orderDiscTitles.indexOf(codeUpper) === -1) {
          // Check if it's a product discount (COMBO)
          var isProductDiscount = false;
          cart.items.forEach(function(item) {
            if (item.line_level_discount_allocations) {
              item.line_level_discount_allocations.forEach(function(alloc) {
                if ((alloc.discount_application || {}).title &&
                    alloc.discount_application.title.toUpperCase() === codeUpper) {
                  isProductDiscount = true;
                }
              });
            }
          });
          if (!isProductDiscount) hasFreeShippingCode = true;
        }
      });
    }
    var shippingCents = (shopifyTotal >= t1 || hasFreeShippingCode) ? 0 : 395;
    _hasFreeShippingCode = hasFreeShippingCode;
    if (shEl) {
      shEl.textContent = shippingCents === 0 ? 'Gratuite' : '3,95\u20AC';
      shEl.style.color = shippingCents === 0 ? 'var(--utcart-green)' : '';
      shEl.style.fontWeight = '600';
    }

    // ── DISCOUNT LINE ──
    if (discLine && discVal) {
      if (totalDiscount > 0) {
        discVal.textContent = '-' + fmt(totalDiscount);
        discVal.style.color = 'var(--utcart-green)';
        discVal.style.fontWeight = '600';
        discLine.style.display = '';
      } else {
        discLine.style.display = 'none';
      }
    }

    // ── GRAND TOTAL ──
    var surcharge = codChecked ? codSurcharge : 0;
    var grandTotal = shopifyTotal + shippingCents + surcharge;

    if (toEl) {
      toEl.textContent = fmt(grandTotal);
    }
  }

  // ========================
  // PROGRESS BAR
  // ========================
  function renderProgress(totalCents) {
    var msgEl = document.getElementById('utcart-progress-msg');
    if (!msgEl) return;

    if (availableGiftCount >= 2 && totalCents >= t3) {
      msgEl.innerHTML = 'Tous les cadeaux d\u00E9bloqu\u00E9s !';
      msgEl.classList.add('utcart-progress__message--complete');
    } else if (availableGiftCount >= 2 && totalCents >= t2) {
      msgEl.innerHTML = 'Ajoutez <b>' + fmt(t3 - totalCents) + '</b> pour recevoir un autre Cadeau';
      msgEl.classList.remove('utcart-progress__message--complete');
    } else if (availableGiftCount >= 1 && totalCents >= t2) {
      msgEl.innerHTML = 'Vous avez d\u00E9bloqu\u00E9 votre cadeau !';
      msgEl.classList.add('utcart-progress__message--complete');
    } else if (availableGiftCount >= 1 && totalCents >= t1) {
      msgEl.innerHTML = 'Ajoutez <b>' + fmt(t2 - totalCents) + '</b> pour recevoir un Cadeau';
      msgEl.classList.remove('utcart-progress__message--complete');
    } else if (_hasFreeShippingCode && availableGiftCount >= 1) {
      msgEl.innerHTML = 'Livraison Gratuite ! Ajoutez <b>' + fmt(t2 - totalCents) + '</b> pour un Cadeau';
      msgEl.classList.remove('utcart-progress__message--complete');
    } else if (totalCents >= t1 || _hasFreeShippingCode) {
      msgEl.innerHTML = 'Livraison Gratuite !';
      msgEl.classList.add('utcart-progress__message--complete');
    } else {
      msgEl.innerHTML = 'Ajoutez <b>' + fmt(t1 - totalCents) + '</b> pour la Livraison Gratuite';
      msgEl.classList.remove('utcart-progress__message--complete');
    }

    var setF = function(id, pct) { var e = document.getElementById(id); if (e) e.style.transform = 'scaleX(' + (Math.min(100, Math.max(0, pct)) / 100) + ')'; };
    var setN = function(id, a) { var e = document.getElementById(id); if (e) e.classList.toggle('utcart-progress__node--active', a); };

    var effectiveFreeShipping = totalCents >= t1 || _hasFreeShippingCode;
    setF('utcart-fill-1', effectiveFreeShipping ? 100 : (totalCents / t1) * 100);
    setN('utcart-node-1', effectiveFreeShipping);

    if (availableGiftCount >= 1) {
      setF('utcart-fill-2', totalCents <= t1 ? 0 : ((totalCents - t1) / (t2 - t1)) * 100);
      setN('utcart-node-2', totalCents >= t2);
    }
    if (availableGiftCount >= 2) {
      setF('utcart-fill-3', totalCents <= t2 ? 0 : ((totalCents - t2) / (t3 - t2)) * 100);
      setN('utcart-node-3', totalCents >= t3);
    }
  }

  // ========================
  // CART API
  // ========================
  function updateQty(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function() { renderCart(); }).catch(function(err) { console.error('UTcart v2:', err); });
  }

  // ========================
  // ADD TO CART (global)
  // ========================
  function handleAddToCart(el, flag) {
    var varId;
    if (el.dataset.variantId) {
      varId = el.dataset.variantId;
    } else if (flag) {
      varId = document.getElementById('varId-' + el.dataset.inputid)?.value;
    } else {
      var params = new URLSearchParams(window.location.search);
      varId = params.get('variant') || document.getElementById('varId-' + el.dataset.inputid)?.value;
    }
    if (!varId) return;

    var quantity = document.querySelector('[id^="product_quantity-"]')?.value || 1;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +varId, quantity: +quantity }] })
    }).then(function() { openCart(); }).catch(function(err) { console.error('UTcart v2:', err); });
  }

  // ========================
  // DISCOUNT TOGGLE (3-state: toggle | panel | badges)
  // ========================
  var discToggle = document.getElementById('utcart-discount-toggle');
  var discToggleWrap = document.getElementById('utcart-discount-toggle-wrap');
  var discPanel = document.getElementById('utcart-discount-panel');
  var discBadgesRow = document.getElementById('utcart-discount-badges-row');
  var discCloseBtn = document.getElementById('utcart-discount-close');
  var discAddAnother = document.getElementById('utcart-discount-add-another');

  function _isJunkCode(code) {
    if (!code) return true;
    var u = code.toUpperCase();
    return u === 'TBN_REMOVE_DISCOUNT_CODES' || u.indexOf('TBN_REMOVE') === 0;
  }

  function updateDiscountUI() {
    // Determine which state to show — ONLY count codes confirmed applicable by cart API
    var hasCodes = false;
    var totalCodes = 0;

    // Build set of applicable codes from cart API (source of truth)
    var applicableCodes = [];
    if (lastCart && lastCart.discount_codes) {
      lastCart.discount_codes.forEach(function(dc) {
        if (dc.applicable !== false && dc.code && !_isJunkCode(dc.code)) {
          applicableCodes.push(dc.code.toUpperCase());
        }
      });
    }

    // Count userCodes that are actually applicable in Shopify
    userCodes.forEach(function(c) {
      if (!_isJunkCode(c) && applicableCodes.indexOf(c) > -1) totalCodes++;
    });
    // Also count applicable codes not in userCodes (Klaviyo, URL, etc.)
    applicableCodes.forEach(function(c) {
      if (userCodes.indexOf(c) === -1) totalCodes++;
    });

    hasCodes = totalCodes > 0;
    var panelOpen = discPanel && discPanel.style.display !== 'none';

    if (hasCodes) {
      // Show badges row, hide toggle
      if (discToggleWrap) discToggleWrap.style.display = 'none';
      if (discBadgesRow) discBadgesRow.style.display = '';
      if (discAddAnother) {
        discAddAnother.style.display = (totalCodes < S.max_discount_codes && !panelOpen) ? '' : 'none';
      }

      // NDK 2026-08: purger de userCodes/cookie les codes que la session conserve mais
      // que Shopify marque non applicables (écartés par un code non cumulable).
      // La session les garde: s'ils redeviennent applicables, le badge se re-adopte seul.
      if (userCodes.length > 0 && lastCart) {
        var displaced = userCodes.filter(function(c) { return applicableCodes.indexOf(c) === -1; });
        if (displaced.length > 0) {
          userCodes = userCodes.filter(function(c) { return applicableCodes.indexOf(c) > -1; });
          var syncCodes = userCodes.join(',');
          if (userCodes.length === 0) {
            document.cookie = 'discount_code=; path=/; max-age=0';
            try { localStorage.removeItem('coupon'); } catch(e) {}
          } else {
            document.cookie = 'discount_code=' + encodeURIComponent(syncCodes) + '; path=/; max-age=2592000';
            try { localStorage.setItem('coupon', syncCodes); } catch(e) {}
          }
          displaced.forEach(function(c) {
            if (!_displacedNotified[c]) {
              _displacedNotified[c] = true;
              showDiscNotice('Le code ' + c + ' a été désactivé (non cumulable avec le code appliqué)');
            }
          });
        }
      }
    } else {
      // No applicable codes: show toggle (if panel not open), hide badges
      if (discBadgesRow) discBadgesRow.style.display = 'none';
      if (discToggleWrap) discToggleWrap.style.display = panelOpen ? 'none' : '';

      // Clean up stale codes from cookie/localStorage
      if (userCodes.length > 0 && lastCart) {
        var staleCodes = userCodes.filter(function(c) { return applicableCodes.indexOf(c) === -1; });
        if (staleCodes.length > 0) {
          userCodes = userCodes.filter(function(c) { return applicableCodes.indexOf(c) > -1; });
          if (userCodes.length === 0) {
            document.cookie = 'discount_code=; path=/; max-age=0';
            try { localStorage.removeItem('coupon'); } catch(e) {}
          } else {
            var allCodes = userCodes.join(',');
            document.cookie = 'discount_code=' + encodeURIComponent(allCodes) + '; path=/; max-age=2592000';
            try { localStorage.setItem('coupon', allCodes); } catch(e) {}
          }
          // Show one-time expired notification
          if (!_expiredNotified) {
            _expiredNotified = true;
            showDiscError('Le code a expiré');
            _keepError = true;
            // Auto-dismiss after 5 seconds
            setTimeout(function() { hideDiscError(); }, 5000);
          }
        }
      }
    }
  }

  function openDiscountPanel() {
    if (discPanel) discPanel.style.display = '';
    if (discToggleWrap) discToggleWrap.style.display = 'none';
    if (discAddAnother) discAddAnother.style.display = 'none';
    if (discInput) { discInput.value = ''; discInput.focus(); }
    hideDiscError();
  }

  function closeDiscountPanel() {
    if (discPanel) discPanel.style.display = 'none';
    hideDiscError();
    updateDiscountUI();
  }

  if (discToggle) discToggle.addEventListener('click', openDiscountPanel);
  if (discCloseBtn) discCloseBtn.addEventListener('click', closeDiscountPanel);
  if (discAddAnother) discAddAnother.addEventListener('click', openDiscountPanel);

  // ========================
  // ========================
  // DISCOUNT APPLY / REMOVE
  // ========================
  var discInput = document.getElementById('utcart-discount-input');
  var discApplyBtn = document.getElementById('utcart-discount-apply');
  var discError = document.getElementById('utcart-discount-error');
  var discBadges = document.getElementById('utcart-discount-badges');

  /**
   * DESIGN:
   * - We track codes the user applied via UTcart in `userCodes` (array of strings).
   * - Hydrate on load from cookie/localStorage (1 code max from external sources).
   * - Validate on apply: snapshot total_discount BEFORE, apply, check AFTER increased.
   * - Badge rendering: only from `userCodes`, NOT from cart.discount_codes (which accumulates junk).
   * - Discount line in footer: diff between original_line_price sum and final_line_price sum
   *   (this captures all code-based discounts accurately).
   * - Price display: item.original_line_price vs item.final_line_price (Shopify source of truth).
   */
  // Hydrate from cookie/localStorage — supports multiple codes (comma-separated)
  (function hydrateDiscountCodes() {
    var cookieMatch = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    var cookieCode = cookieMatch ? decodeURIComponent(cookieMatch[1]).trim() : '';
    var lsCode = '';
    try { lsCode = (localStorage.getItem('coupon') || '').trim(); } catch(e) {}
    var raw = cookieCode || lsCode;
    if (!raw) return;
    // Split comma-separated codes
    raw.split(',').forEach(function(c) {
      c = c.trim().toUpperCase();
      if (c.length >= 2 && userCodes.indexOf(c) === -1) {
        userCodes.push(c);
      }
    });
  })();

  var _discountBusy = null; // null = idle, Promise = operation in progress
  var _pendingApply = null; // code queued while another operation runs

  function applyDiscountCode() {
    if (!discInput) return;
    var code = discInput.value.trim();
    if (!code) return;
    var upper = code.toUpperCase();

    // NDK 2026-08 (bug codes non cumulables): les pre-checks se basent sur les codes
    // que Shopify marque APPLICABLES, pas sur userCodes — un code écarté par un autre
    // non cumulable restait dans userCodes et bloquait la re-tentative.
    var applicableNow = [];
    if (lastCart && lastCart.discount_codes) {
      lastCart.discount_codes.forEach(function(dc) {
        if (dc.applicable !== false && dc.code && !_isJunkCode(dc.code)) {
          applicableNow.push(dc.code.toUpperCase());
        }
      });
    }
    if (applicableNow.length >= S.max_discount_codes) {
      showDiscError('Maximum ' + S.max_discount_codes + ' codes autorisés');
      return;
    }
    if (applicableNow.indexOf(upper) > -1) {
      showDiscError('Ce code a déjà été appliqué');
      return;
    }

    discApplyBtn.disabled = true;
    hideDiscError();
    discInput.value = '';
    showLoading();

    if (_discountBusy) {
      // Queue: will execute after current operation finishes
      _pendingApply = code;
      return;
    }

    _doApply(code);
  }

  function _doApply(code) {
    _discountBusy = _applyCore(code)
      .finally(function() {
        _discountBusy = null;
        discApplyBtn.disabled = false;
        hideLoading();
        // Shopify may register the code in cart.js after our confirmation
        // window closes — re-check later and repaint badges only if they
        // don't match what Shopify reports (no-op in the happy path).
        [2500, 6000].forEach(function(delay) {
          setTimeout(function() {
            getCartJson().then(function(c) {
              var fresh = (c.discount_codes || []).filter(function(dc) {
                return dc.applicable !== false && !_isJunkCode(dc.code);
              }).map(function(dc) { return (dc.code || '').toUpperCase(); }).sort().join(',');
              var shown = Array.prototype.map.call(
                document.querySelectorAll('#utcart-discount-badges .utcart-discount-pill'),
                function(p) { return (p.dataset.code || '').toUpperCase(); }
              ).sort().join(',');
              if (fresh !== shown) { lastCart = c; renderDiscountBadges(); }
            }).catch(function() {});
          }, delay);
        });
        if (_pendingApply) {
          var next = _pendingApply;
          _pendingApply = null;
          _doApply(next);
        }
      });
  }

  /**
   * Core apply logic.
   * KEY INSIGHT: Let DiscountCoupon.applyNow() do ALL the heavy lifting.
   * It handles: /discount/CODE -> wait -> /cart.js -> detect type -> coupon_data -> PDP prices.
   * We just need to wait for it to finish, then update our cart drawer.
   */
  function _applyCore(code) {
    // Snapshot cart state BEFORE applying (to detect shipping-only codes later)
    var preApplyDiscountTotal = lastCart ? (lastCart.total_discount || 0) : 0;
    var preApplyCodeCount = lastCart && lastCart.discount_codes ? lastCart.discount_codes.length : 0;

    // Use DiscountCoupon.applyNow if available (handles /discount/CODE + PDP prices)
    var applyPromise;
    if (window.discountCoupon && typeof window.discountCoupon.applyNow === 'function') {
      applyPromise = window.discountCoupon.applyNow(code);
      // applyNow is async — returns a promise (or undefined in old impls)
      if (!applyPromise || typeof applyPromise.then !== 'function') {
        // Fallback if applyNow doesn't return a promise — wait 800ms
        applyPromise = new Promise(function(r) { setTimeout(r, 800); });
      }
    } else {
      // No DiscountCoupon — manual apply
      applyPromise = fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'follow' })
        .catch(function() {})
        .then(function() { return new Promise(function(r) { setTimeout(r, 600); }); });
    }

    return applyPromise
      .then(function() {
        // Now check cart.js to confirm
        return getCartJson();
      })
      .then(function(cart) {
        lastCart = cart;
        // Check if code is in discount_codes
        var found = false;
        var invalid = false;
        if (cart.discount_codes) {
          cart.discount_codes.forEach(function(dc) {
            if (dc.code && dc.code.toUpperCase() === code.toUpperCase()) {
              found = true;
              if (dc.applicable === false) invalid = true;
            }
          });
        }

        if (invalid) {
          showDiscError(discountRejectedMessage());
          _keepError = true;
          return renderCart();
        }

        if (!found) {
          // Not found yet — applyNow already waited ~400ms. Try once more.
          return new Promise(function(r) { setTimeout(r, 600); })
            .then(function() { return getCartJson(); })
            .then(function(cart2) {
              lastCart = cart2;
              var found2 = false, invalid2 = false;
              if (cart2.discount_codes) {
                cart2.discount_codes.forEach(function(dc) {
                  if (dc.code && dc.code.toUpperCase() === code.toUpperCase()) {
                    found2 = true;
                    if (dc.applicable === false) invalid2 = true;
                  }
                });
              }
              if (invalid2) {
                showDiscError(discountRejectedMessage());
                _keepError = true;
                return renderCart();
              }
              if (!found2) {
                // Code not in cart API — check if something changed (shipping-only codes
                // may not appear in discount_codes but do change the code count or discount total)
                var postCodeCount = cart2.discount_codes ? cart2.discount_codes.length : 0;
                var postDiscountTotal = cart2.total_discount || 0;
                var somethingChanged = (postCodeCount > preApplyCodeCount) || (postDiscountTotal > preApplyDiscountTotal);
                if (somethingChanged) {
                  // Likely a shipping-only or hidden code — accept it
                  return _finishApply(code, cart2);
                }
                // Nothing changed — code is expired/invalid
                showDiscError(discountRejectedMessage());
                _keepError = true;
                return renderCart();
              }
              return _finishApply(code, cart2);
            });
        }

        return _finishApply(code, cart);
      });
  }

  function _finishApply(code, cart) {
    if (userCodes.indexOf(code.toUpperCase()) === -1) {
      userCodes.push(code.toUpperCase());
    }
    // Persist — but DON'T call applyNow again (already called above)
    var allCodes = userCodes.join(',');
    document.cookie = 'discount_code=' + encodeURIComponent(allCodes) + '; path=/; max-age=2592000';
    try { localStorage.setItem('coupon', allCodes); } catch(e) {}

    detectDiscount(cart);

    // Check if this is a fixed amount discount and update the flag
    var apps = cart.cart_level_discount_applications || [];
    _isFixedAmountCode = false;
    apps.forEach(function(d) {
      if (d.value_type === 'fixed_amount') _isFixedAmountCode = true;
    });

    // If fixed amount, revert any PDP price PAINTING only.
    // NDK 2026-08: préférer revertCards (DOM seulement) — revertPrices() du moteur
    // efface aussi cookie/localStorage alors que la remise reste active.
    if (_isFixedAmountCode && window.discountCoupon) {
      if (typeof window.discountCoupon.revertCards === 'function') {
        window.discountCoupon.revertCards();
      } else if (typeof window.discountCoupon.revertPrices === 'function') {
        window.discountCoupon.revertPrices();
      }
    }

    renderDiscountBadges();
    return renderCart();
  }

  function removeDiscountCode(code) {
    var upper = code.toUpperCase();
    var idx = userCodes.indexOf(upper);
    if (idx > -1) userCodes.splice(idx, 1);
    // Track as explicitly removed so sync doesn't re-adopt it
    if (_removedCodes.indexOf(upper) === -1) _removedCodes.push(upper);

    // Immediately update UI
    renderDiscountBadges();
    showLoading();

    _discountBusy = _removeCore()
      .finally(function() {
        _discountBusy = null;
        hideLoading();
        if (_pendingApply) {
          var next = _pendingApply;
          _pendingApply = null;
          _doApply(next);
        }
      });
  }

  var _removedCodes = []; // Track codes user explicitly removed, to prevent re-adoption

  function _removeCore() {
    _cachedDiscount = null;
    _codeShares = null;

    // Step 1: Clear ALL discounts via multiple methods for compatibility
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        }).catch(function(){})
      .then(function() {
        // Also try /discount/ clear endpoint
        return fetch('/discount/', { method: 'GET', redirect: 'follow' }).catch(function(){});
      })
      .then(function() {
        // Wait and confirm clear
        return new Promise(function(r) { setTimeout(r, 800); });
      })
      .then(function() {
        return getCartJson();
      })
      .then(function(cart) {
        lastCart = cart;
        // If still has codes, try one more time
        if (cart.discount_codes && cart.discount_codes.some(function(dc) { return dc.applicable; })) {
          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' })
          }).catch(function(){})
          .then(function() { return new Promise(function(r) { setTimeout(r, 500); }); });
        }
      })
      .then(function() {
        // Step 2: Re-apply remaining codes using applyNow for each
        if (userCodes.length > 0) {
          var chain = Promise.resolve();
          userCodes.forEach(function(c) {
            chain = chain.then(function() {
              if (window.discountCoupon && typeof window.discountCoupon.applyNow === 'function') {
                var p = window.discountCoupon.applyNow(c);
                if (p && typeof p.then === 'function') return p;
                return new Promise(function(r) { setTimeout(r, 600); });
              } else {
                return fetch('/discount/' + encodeURIComponent(c), { method: 'GET', redirect: 'follow' })
                  .catch(function(){})
                  .then(function() { return new Promise(function(r) { setTimeout(r, 400); }); });
              }
            });
          });
          return chain.then(function() {
            var allCodes = userCodes.join(',');
            document.cookie = 'discount_code=' + encodeURIComponent(allCodes) + '; path=/; max-age=2592000';
            try { localStorage.setItem('coupon', allCodes); } catch(e) {}
          });
        } else {
          clearDiscountPersistence();
          if (window.discountCoupon && window.discountCoupon.revertPrices) {
            window.discountCoupon.revertPrices();
          }
        }
      })
      .then(function() { return renderCart(); })
      .then(function() { renderDiscountBadges(); });
  }

  function persistDiscount(code) {
    var allCodes = userCodes.join(',');
    document.cookie = 'discount_code=' + encodeURIComponent(allCodes) + '; path=/; max-age=2592000';
    try { localStorage.setItem('coupon', allCodes); } catch(e) {}
    // NOTE: applyNow is called in _applyCore, not here, to avoid double-calling
  }

  function clearDiscountPersistence() {
    document.cookie = 'discount_code=; path=/; max-age=0';
    try {
      localStorage.removeItem('coupon');
      localStorage.removeItem('coupon_data');
    } catch(e) {}
    _isFixedAmountCode = false;
    if (window.DiscountCoupon) {
      window.discountCoupon = new window.DiscountCoupon();
    }
  }
  function renderDiscountBadges() {
    if (!discBadges) return;
    var tpl = document.getElementById('utcart-tpl-discount-badge');
    if (!tpl) return;
    discBadges.innerHTML = '';

    // Sync: adopt applicable cart API codes into userCodes (covers Klaviyo, URL /discount/CODE, etc.)
    if (lastCart && lastCart.discount_codes) {
      lastCart.discount_codes.forEach(function(dc) {
        if (dc.applicable !== false && dc.code && !_isJunkCode(dc.code)) {
          var code = dc.code.toUpperCase();
          // Don't re-adopt codes the user explicitly removed
          if (userCodes.indexOf(code) === -1 && _removedCodes.indexOf(code) === -1) {
            userCodes.push(code);
            // Persist so they survive page refreshes
            var allCodes = userCodes.join(',');
            document.cookie = 'discount_code=' + encodeURIComponent(allCodes) + '; path=/; max-age=2592000';
            try { localStorage.setItem('coupon', allCodes); } catch(e) {}
          }
        }
      });
    }

    // Only show codes that Shopify has actually applied (not phantom codes from cookie/localStorage)
    var activeCodes = [];
    if (lastCart && lastCart.discount_codes) {
      lastCart.discount_codes.forEach(function(dc) {
        if (dc.applicable !== false && !_isJunkCode(dc.code)) {
          var code = (dc.code || '').toUpperCase();
          if (code && activeCodes.indexOf(code) === -1) activeCodes.push(code);
        }
      });
    }

    if (activeCodes.length === 0) {
      if (discBadgesRow) discBadgesRow.style.display = 'none';
      updateDiscountUI();
      return;
    }

    activeCodes.forEach(function(code) {
      var clone = tpl.content.cloneNode(true);
      var pill = clone.querySelector('.utcart-discount-pill');
      pill.dataset.code = code;
      pill.querySelector('.utcart-discount-pill__code').textContent = code;
      var amountEl = pill.querySelector('.utcart-discount-pill__amount');
      if (amountEl) amountEl.style.display = 'none';
      pill.querySelector('.utcart-discount-pill__remove').addEventListener('click', function() {
        removeDiscountCode(code);
      });
      discBadges.appendChild(clone);
    });

    // Close panel after successful apply — mais PAS quand une erreur est affichée.
    // NDK 2026-08: avec un autre code déjà appliqué, cette fermeture effaçait
    // "Code non valide" instantanément.
    if (!discError || discError.style.display === 'none') {
      closeDiscountPanel();
    }
    updateDiscountUI();
  }

  /**
   * NDK 2026-08: avis à côté des badges (visible même panneau fermé).
   * Se masque après 6s.
   */
  function showDiscNotice(msg) {
    var anchor = discBadgesRow || discPanel;
    if (!anchor || !anchor.parentNode) return;
    var n = document.getElementById('utcart-discount-notice');
    if (!n) {
      n = document.createElement('div');
      n.id = 'utcart-discount-notice';
      n.className = 'utcart-discount__error';
      n.style.marginTop = '6px';
      anchor.parentNode.insertBefore(n, anchor.nextSibling);
    }
    n.textContent = msg;
    n.style.display = '';
    clearTimeout(n._ndkTimer);
    n._ndkTimer = setTimeout(function() { n.style.display = 'none'; }, 6000);
  }

  /**
   * Mensaje para un código que Shopify ha rechazado.
   *
   * Cuando el carrito lleva un pack, el descuento del pack es AUTOMÁTICO y de clase producto, y
   * casi todos los códigos de la tienda también son de clase producto y no combinan con nada. En
   * ese choque Shopify rechaza el código y deja el del pack, que además suele ser mayor — pero
   * «Code non valide» le hace creer al cliente que su código es falso, y eso acaba en un email
   * a atención al cliente. Aquí se le dice lo que pasa de verdad.
   */
  function discountRejectedMessage() {
    var hasPack = lastCart && lastCart.items && lastCart.items.some(isPackItem);
    var packDiscounted = lastCart && lastCart.items && lastCart.items.some(function (i) {
      return isPackItem(i) && i.final_line_price < i.original_line_price;
    });
    if (hasPack && packDiscounted) {
      return 'Code non compatible avec le Pack';
    }
    return 'Code non valide ou non applicable';
  }

  function showDiscError(msg) {
    if (discError) { discError.textContent = msg; discError.style.display = ''; }
  }
  function hideDiscError() {
    if (discError) discError.style.display = 'none';
  }

  if (discApplyBtn) discApplyBtn.addEventListener('click', applyDiscountCode);
  if (discInput) discInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); applyDiscountCode(); }
  });

  renderDiscountBadges();
  updateDiscountUI();


  // ========================
  // COD CHECKBOX
  // ========================
  var codBox = document.getElementById('utcart-cod-checkbox');
  if (codBox) {
    codBox.addEventListener('change', function() {
      codChecked = codBox.checked;
      if (lastCart) renderFooter(lastCart);
    });
  }

  // ========================
  // EXPOSE GLOBALS
  // ========================
  window.openCart = openCart;
  window.closeCart = closeCart;
  window.handleAddToCart = handleAddToCart;

  // Sync cart count on page load (partage la requête avec le check du patch ci-dessous)
  getCartJson()
    .then(function(cart) { updateCartCount(cart); })
    .catch(function() {});

  // Monkey-patch DiscountCoupon.initProductsHandler to skip fixed-amount discounts.
  // Fixed discounts (e.g. -5€) apply to the ORDER total, not per-product.
  // CRITICAL: global.js misclassifies fixed amounts as DiscountPercentage when the ratio
  // happens to be a clean number (e.g. 500/12480 ≈ 4%). So we can't rely on discountData.__typename.
  // Instead, we check the cart API's value_type which is the source of truth.
  var _isFixedAmountCode = false; // set by cart fetch below

  (function patchDiscountCoupon() {
    function shouldBlock() {
      return _isFixedAmountCode;
    }

    function doPatch(dc) {
      if (dc._utcartPatched) return;
      var original = dc.initProductsHandler;
      if (typeof original !== 'function') return;
      dc.initProductsHandler = function() {
        if (shouldBlock()) return;
        return original.apply(this, arguments);
      };
      dc._utcartPatched = true;
    }

    if (window.discountCoupon) doPatch(window.discountCoupon);

    // NDK 2026-08: patch du prototype supprimé — sur FR window.DiscountCoupon est la
    // factory de ndk-discount-engine (prototype vide); le patch de l'instance ci-dessus
    // suffit. NB: new window.DiscountCoupon() dans clearDiscountPersistence reste ACTIF.

    // Check cart to determine if active discount is fixed_amount
    getCartJson()
      .then(function(cart) {
        var apps = cart.cart_level_discount_applications || [];
        apps.forEach(function(d) {
          if (d.value_type === 'fixed_amount') {
            _isFixedAmountCode = true;
          }
        });
        // If fixed and prices already painted, revert PAINTING only (voir note plus haut)
        if (_isFixedAmountCode && window.discountCoupon) {
          if (typeof window.discountCoupon.revertCards === 'function') {
            window.discountCoupon.revertCards();
          } else if (typeof window.discountCoupon.revertPrices === 'function') {
            window.discountCoupon.revertPrices();
          }
        }
      })
      .catch(function() {});
  })();

})();
